import type { LegalDocumentType } from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile'
import type { I18n, I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

import { DOCUMENT_DESCRIPTIONS } from './LegalDocuments.constants'

export function getDocumentDescription(i18n: I18n, type: LegalDocumentType) {
  return DOCUMENT_DESCRIPTIONS[type]
    ? i18n(DOCUMENT_DESCRIPTIONS[type] as I18nDefinition)
    : ''
}
